"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _mapBox = _interopRequireDefault(require("@/components/map/mapBox"));
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _merchant = require("@/api/merchant");
var _status = require("@/api/iot/status");
var _branch = require("@/api/iot/branch");
var _default = {
  props: ['editItem', 'roleList'],
  components: {
    mapBox: _mapBox.default,
    cropUpload: _cropUpload.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      btnLoading: false,
      map: {
        longitudelatitude: ''
      },
      form: {
        id: '',
        merchant_id: '',
        name: '',
        imgs: [],
        // company_name: '',
        // serve_mobile: '',
        // examine_status: '',
        address: '',
        longitude: '',
        latitude: '',
        status: 0,
        // service_time: '',
        // end_time: '',
        // branch_type: '',
        remark: '',
        right_top: 0 // 0 不倾斜 1 倾斜
        // electricity_price: '',
        // is_discount: '',
      },

      merchantList: [],
      branchStatusList: [],
      labelSiteList: [{
        id: 0,
        label: '不倾斜'
      }, {
        id: 1,
        label: '倾斜'
      }],
      rules: {
        merchant_id: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入网点名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入网点地址',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return (this.editItem ? '修改' : '添加') + '网点';
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            // this.form = this.editItem
            for (var key in _this.form) {
              _this.form[key] = _this.editItem[key];
            }
            _this.map.longitudelatitude = _this.form.longitude + ',' + _this.form.latitude;
          }
        });
      } else {
        this.map = this.$options.data().map;
        this.form = this.$options.data().form;
        this.$refs['form'].resetFields();
      }
    }
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getBranchStatusList();
  },
  methods: {
    getBranchStatusList: function getBranchStatusList() {
      var _this2 = this;
      (0, _status.getBranchStatusList)().then(function (res) {
        console.log('getBranchStatusList', res);
        if (res) {
          _this2.branchStatusList = res || [];
        }
      });
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    sendPointInfo: function sendPointInfo(info) {
      // console.log('sendPointInfo', info)
      this.form.address = info.address;
      this.form.longitude = info.point.lng;
      this.form.latitude = info.point.lat;
      this.map.longitudelatitude = info.point.lng + ',' + info.point.lat;
    },
    imgChange: function imgChange(val, type) {
      if (type === 'sort') {
        this.form.imgs = val;
        return;
      }
      if (type === 'del') {
        this.form.imgs.splice(val, 1);
      } else {
        this.form.imgs.push(val);
      }
      this.$refs.cropUpload.sortList = this.form.imgs;
    },
    submit: function submit() {
      var _this3 = this;
      this.$refs['form'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(valid) {
          var res;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 9;
                    break;
                  }
                  _this3.btnLoading = true;
                  _context2.next = 4;
                  return (0, _branch.branchSave)(_this3.form).catch(function () {});
                case 4:
                  res = _context2.sent;
                  _this3.btnLoading = false;
                  if (res) {
                    _this3.dialogVisible = false;
                    _this3.$emit('getList');
                  }
                  _context2.next = 11;
                  break;
                case 9:
                  _this3.$message({
                    message: '请检查表单错误',
                    type: 'error'
                  });
                  return _context2.abrupt("return", false);
                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};
exports.default = _default;